<script>
    import { Col, Label, Row } from "sveltestrap";
    import { CustomLable } from "../../../utils/Constant/Constant";
    import RangeSlider from 'svelte-range-slider-pips';
    const moods = ['😁', '😀', '😊', '😐', '😥', '😫'];
    // use the Intl formatter to add the correct number notation
    const num = new Intl.NumberFormat('en-US')
</script>
<Row class="form-group">
    <Label class="col-md-2 sm-left-text">{CustomLable}</Label>
    <Col md="10">
      <RangeSlider
        pips
        formatter={(v) => moods[v]}
        max={moods.length - 1}
        all="label" />
    </Col>
</Row>